import { useGetDevelopmentDatabaseInfo } from '@/api/generated/ping/ping';
import { getRuntimeConfig } from '@/shared/runtimeConfig';
import { envColor } from '@/shared/common/envColors';

export function DevelopmentDatabaseBadge() {
  const { data, isLoading, isError } = useGetDevelopmentDatabaseInfo({
    query: {
      staleTime: Infinity,
      retry: false,
    },
  });

  if (isLoading || isError || data === undefined || isProductionEnvironment(data.environmentName)) {
    return null;
  }

  const label = data.databaseName
    ? `ENV: ${data.environmentName} | DB: ${data.databaseName}`
    : `ENV: ${data.environmentName}`;

  // Barva shodná s proužkem prostředí v hlavním menu (dle environment badge — dev modrá, env zelená).
  const color = envColor(getRuntimeConfig().app.environment).bg;

  return (
    <span
      className="text-phx-xs inline-flex min-w-28 justify-end font-medium tracking-wide"
      style={{ color }}
      data-testid="main-menu-runtime-info"
      title={label}
    >
      {label}
    </span>
  );
}

function isProductionEnvironment(environmentName: string): boolean {
  return environmentName.localeCompare('Production', undefined, { sensitivity: 'accent' }) === 0;
}
